import StatementsPage, {
  statementsQuery,
} from "@app/pages/statements/statements-page";
import type { statementsPage_Query } from "@app/queries/statementsPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/statements/")({
  loader: () =>
    loadQuery<statementsPage_Query>(
      environment,
      statementsQuery,
      {},
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Statements"),
  component: StatementsRoute,
});

function StatementsRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">
          Error loading statements registry
        </div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Loading statements...</div>
        }
      >
        <StatementsPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
